var render, staticRenderFns
import script from "./InputBoxProps.vue?vue&type=script&lang=js"
export * from "./InputBoxProps.vue?vue&type=script&lang=js"
import style0 from "./InputBoxProps.vue?vue&type=style&index=0&id=61c932a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports